module.exports = __webpack_public_path__ + "static/media/PACOCA.a429ee97.svg";